/**
 * Startup timing. `window.__bootStart` is set by an inline script in index.html; we mark
 * when local data is in memory and when the first screen has painted.
 */
export interface StartupTimes {
  hydratedMs: number | null;
  firstPaintMs: number | null;
}

let times: StartupTimes = { hydratedMs: null, firstPaintMs: null };

export function startPerfMarks() {
  const start = window.__bootStart ?? 0;
  const hydrated = performance.getEntriesByName('hydrated')[0];
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      times = {
        hydratedMs: hydrated ? Math.round(hydrated.startTime - start) : null,
        firstPaintMs: Math.round(performance.now() - start),
      };
      performance.mark('first-screen');
      if (import.meta.env.DEV || new URLSearchParams(location.search).has('perf')) {
        console.info(
          `[startup] hydrated ${times.hydratedMs} ms, first screen ${times.firstPaintMs} ms after HTML`,
        );
      }
    }),
  );
}

export function startupTimes(): StartupTimes {
  return times;
}
